import { Alpine } from 'alpinejs';

declare global {
  interface Window {
    Alpine: Alpine;
  }
}

export const archiveList = () => ({
  currentPage: 1,
  maxPages: 1,
  loadingNext: false,
  filtersHasScroll: false,
  openFilters: false,

  init() {
    this.updateCurrentPage();

    // Check on window resize
    window.addEventListener('resize', () => {
      this.checkFiltersScroll();
    });

    // Listen for filters open/close
    this.$watch('openFilters', (value) => {
      if (value) {
        this.$nextTick(() => {
          this.checkFiltersScroll();
        });
      }
    });
  },

  openModal() {
    this.openFilters = true;

    document
      .querySelector('.js-kross-modal-overlay')
      ?.classList?.add('is-active');
  },

  closeModal() {
    this.openFilters = false;

    document
      .querySelector('.js-kross-modal-overlay')
      ?.classList?.remove('is-active');
  },

  checkFiltersScroll() {
    if (this.$refs.filtersContent) {
      this.filtersHasScroll =
        this.$refs.filtersContent.scrollHeight >
        this.$refs.filtersContent.clientHeight;
    }
  },

  loadMore(url: string) {
    this.loadingNext = true;
    this.$ajax(url, {
      target: 'posts_list_paginated posts_list_pager',
    });
  },

  getPageUrl(page: number): string {
    const url = new URL(window.location.href);
    url.searchParams.set('paged', page.toString());
    return url.toString();
  },

  updateCurrentPage() {
    this.$nextTick(() => {
      const blocks = document.querySelectorAll('.b-archive-list__post');
      if (!blocks.length) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const page = entry.target.getAttribute('data-page');
              if (page) {
                this.currentPage = parseInt(page);
                history.replaceState(
                  null,
                  '',
                  this.getPageUrl(this.currentPage),
                );
              }
            }
          });
        },
        {
          threshold: 0.5,
        },
      );

      blocks.forEach((block) => observer.observe(block));
    });
  },
});
